"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _spauiUtils = require("@tencent/spaui-utils");

var _info = _interopRequireDefault(require("./info"));

var _buttongroup_compact_props = _interopRequireDefault(require("./buttongroup_compact_props"));

var _buttongroup_props = require("./buttongroup_props");

var _spauiButton = _interopRequireDefault(require("@tencent/spaui-button"));

var _classname_map = _interopRequireDefault(require("./config/classname_map"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var ButtonGroup =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(ButtonGroup, _PureComponent);

  function ButtonGroup(props) {
    var _this;

    _classCallCheck(this, ButtonGroup);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ButtonGroup).call(this, props));
    _this.valueMap = {};
    return _this;
  }

  _createClass(ButtonGroup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.valueMap = null;
    }
  }, {
    key: "getClassNameMap",
    value: function getClassNameMap() {
      var _compactProps = (0, _buttongroup_compact_props["default"])(this.props),
          _compactProps$classNa = _compactProps.classNameMap,
          classNameMap = _compactProps$classNa === void 0 ? {} : _compactProps$classNa;

      return _objectSpread({}, _classname_map["default"], {}, classNameMap);
    }
  }, {
    key: "setChildrenItemClassName",
    value: function setChildrenItemClassName() {
      var originClassName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var index = arguments.length > 1 ? arguments[1] : undefined;
      var length = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var classNameMap = this.getClassNameMap();

      var _compactProps2 = (0, _buttongroup_compact_props["default"])(this.props),
          numberOfRow = _compactProps2.numberOfRow;

      var result = originClassName;
      var autoFillRow = this.props.autoFillRow || false; // 如果小于1行就不自动填充

      if (length < numberOfRow) {
        autoFillRow = false;
      }

      if (typeof numberOfRow !== 'undefined' && numberOfRow > 1 && length > 0) {
        var _classNames;

        var rowIndex = Math.ceil(length / numberOfRow) * numberOfRow - 1;
        result = (0, _classnames["default"])(result, (_classNames = {}, _defineProperty(_classNames, classNameMap.topLeftClassName, index === 0), _defineProperty(_classNames, classNameMap.topRightClassName, index === numberOfRow - 1 || !autoFillRow && length < numberOfRow && index === length - 1), _defineProperty(_classNames, classNameMap.bottomLeftClassName, index === (Math.ceil(length / numberOfRow) - 1) * numberOfRow), _defineProperty(_classNames, classNameMap.bottomRightClassName, index === rowIndex || !autoFillRow && length < numberOfRow && index === length - 1), _classNames));
      }

      return result;
    }
  }, {
    key: "getFillRowChildren",
    value: function getFillRowChildren() {
      var totalChildrenNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var classNameMap = this.getClassNameMap();
      var _this$props = this.props,
          _this$props$numberOfR = _this$props.numberOfRow,
          numberOfRow = _this$props$numberOfR === void 0 ? 0 : _this$props$numberOfR,
          _this$props$ButtonPro = _this$props.ButtonProps,
          ButtonProps = _this$props$ButtonPro === void 0 ? {} : _this$props$ButtonPro;
      var result = null;
      var needCount = 0;
      var i = 0;
      var autoFillRow = this.props.autoFillRow || false; // 如果小于1行就不自动填充

      if (totalChildrenNumber < numberOfRow) {
        autoFillRow = false;
      }

      if (numberOfRow > 1 && autoFillRow && totalChildrenNumber > 0) {
        needCount = numberOfRow - totalChildrenNumber % numberOfRow;

        if (needCount > 0 && needCount < numberOfRow) {
          result = [];

          for (; i < needCount; i++) {
            result.push(_react["default"].createElement(_spauiButton["default"], _extends({}, ButtonProps, {
              key: "spaui-buttongroup-empty-button".concat(i),
              className: this.setChildrenItemClassName(classNameMap.emptyClassName, totalChildrenNumber + i, totalChildrenNumber + needCount, ButtonProps.className || '')
            })));
          }
        }
      }

      return result;
    }
  }, {
    key: "getCloneChildren",
    value: function getCloneChildren() {
      var _this2 = this;

      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var index = arguments.length > 1 ? arguments[1] : undefined;
      var length = arguments.length > 2 ? arguments[2] : undefined;

      var _compactProps3 = (0, _buttongroup_compact_props["default"])(this.props),
          activeDisplayType = _compactProps3.activeDisplayType,
          componentValue = _compactProps3.value,
          onChange = _compactProps3.onChange,
          _compactProps3$multip = _compactProps3.multiple,
          multiple = _compactProps3$multip === void 0 ? false : _compactProps3$multip,
          _compactProps3$disabl = _compactProps3.disabled,
          disabled = _compactProps3$disabl === void 0 ? false : _compactProps3$disabl,
          numberOfRow = _compactProps3.numberOfRow,
          hasSpan = _compactProps3.hasSpan;

      var props = children.props;
      var result = children;
      var childValue = '';
      var cloneElementData = {};
      var value = componentValue;
      var isActive = false;

      if (multiple) {
        if (!(0, _spauiUtils.isArray)(componentValue)) {
          if (componentValue || typeof componentValue === 'number') {
            value = [componentValue];
          }
        }
      }

      if (!(0, _spauiUtils.isUndefined)(props)) {
        childValue = props.value;
        this.valueMap[childValue] = props; // 设置选中属性

        if (multiple) {
          if ((0, _spauiUtils.isArray)(value) && (0, _spauiUtils.indexOf)(value, childValue) > -1) {
            isActive = true;
          }
        } else {
          if ((value || typeof value === 'number') && value === childValue) {
            isActive = true;
          }
        }

        if (isActive) {
          cloneElementData = {
            key: index || null,
            active: true
          };

          if (activeDisplayType) {
            cloneElementData.displayType = activeDisplayType;
          }
        } // 设置回调函数


        if ((0, _spauiUtils.isFunction)(onChange)) {
          cloneElementData.key = index || null;

          cloneElementData.onClick = function (event) {
            var finalValue;
            var valueProps = props;

            if (multiple) {
              if (props.isAlone) {
                if ((0, _spauiUtils.isArray)(value)) {
                  if ((0, _spauiUtils.indexOf)(value, childValue) > -1) {
                    finalValue = [];
                  } else {
                    finalValue = [childValue];
                  }
                } else {
                  if (value === childValue) {
                    finalValue = [];
                  } else {
                    finalValue = [childValue];
                  }
                }
              } else {
                if ((0, _spauiUtils.isArray)(value)) {
                  finalValue = [];
                  value.forEach(function (item) {
                    if (!_this2.valueMap[item] || !_this2.valueMap[item].isAlone) {
                      finalValue.push(item);
                    }
                  });

                  if ((0, _spauiUtils.indexOf)(finalValue, childValue) > -1) {
                    finalValue.splice((0, _spauiUtils.indexOf)(finalValue, childValue), 1);
                  } else {
                    finalValue.push(childValue);
                  }
                } else {
                  if (value === childValue) {
                    finalValue = [];
                  } else {
                    finalValue = [childValue];
                  }
                }
              }

              valueProps = [];
              finalValue.forEach(function (item) {
                if (_this2.valueMap[item]) {
                  valueProps.push(_this2.valueMap[item]);
                }
              });
            } else {
              finalValue = childValue;
            }

            onChange(event, finalValue, valueProps);

            if ((0, _spauiUtils.isFunction)(props.onClick)) {
              props.onClick(event, props);
            }
          };
        }

        if (hasSpan) {
          cloneElementData.hasSpan = true;
        }

        if (typeof cloneElementData.key !== 'undefined' || disabled || typeof numberOfRow !== 'undefined') {
          if (disabled) {
            cloneElementData.disabled = disabled;
          }

          cloneElementData.className = this.setChildrenItemClassName(props.className, index, length);

          if (typeof cloneElementData.key === 'undefined') {
            cloneElementData.key = index;
          }

          result = (0, _react.cloneElement)(result, cloneElementData);
        }
      }

      return result;
    }
  }, {
    key: "getErrorElement",
    value: function getErrorElement() {
      var _compactProps4 = (0, _buttongroup_compact_props["default"])(this.props),
          _compactProps4$turnTi = _compactProps4.turnTipIntoDisplayText,
          turnTipIntoDisplayText = _compactProps4$turnTi === void 0 ? false : _compactProps4$turnTi,
          data = _compactProps4.data,
          children = _compactProps4.children,
          DisplayTextComponent = _compactProps4.DisplayTextComponent;

      var getReactComponentInstanceTip = function getReactComponentInstanceTip() {
        var instance = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var instanceProps = instance.props || {};
        return instanceProps.tip;
      };

      var result = null;
      var isSameTip = false;
      var tip = '';
      var tipCount = 0;
      var componentTip = '';

      if (turnTipIntoDisplayText) {
        if ((0, _spauiUtils.isArray)(data)) {
          data.forEach(function (item) {
            componentTip = item.tip;

            if (componentTip) {
              if (!tip) {
                tip = componentTip;
                tipCount += 1;
              } else if (tip === componentTip) {
                tipCount += 1;
              }
            }
          });

          if (tipCount > 0 && tipCount === data.length) {
            isSameTip = true;
          }
        } else if (children) {
          if ((0, _spauiUtils.isArray)(children)) {
            children.forEach(function (item) {
              componentTip = getReactComponentInstanceTip(item);

              if (componentTip) {
                if (!tip) {
                  tip = componentTip;
                  tipCount += 1;
                } else if (tip === componentTip) {
                  tipCount += 1;
                }
              }
            });

            if (tipCount > 0 && tipCount === children.length) {
              isSameTip = true;
            }
          } else {
            componentTip = getReactComponentInstanceTip(children);

            if (componentTip) {
              tip = componentTip;
              isSameTip = true;
            }
          }
        }

        if (isSameTip && !(0, _spauiUtils.isReactNode)(DisplayTextComponent)) {
          result = _react["default"].createElement(DisplayTextComponent, _extends({}, this.props, {
            classNameMap: this.getClassNameMap()
          }), tip);
        }
      }

      return result;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _compactProps5 = (0, _buttongroup_compact_props["default"])(this.props),
          children = _compactProps5.children,
          bsClass = _compactProps5.bsClass,
          vertical = _compactProps5.vertical,
          justified = _compactProps5.justified,
          block = _compactProps5.block,
          data = _compactProps5.data,
          multiple = _compactProps5.multiple,
          _compactProps5$show = _compactProps5.show,
          show = _compactProps5$show === void 0 ? true : _compactProps5$show,
          _compactProps5$disabl = _compactProps5.disabled,
          disabled = _compactProps5$disabl === void 0 ? false : _compactProps5$disabl,
          theme = _compactProps5.theme,
          _compactProps5$Button = _compactProps5.ButtonProps,
          ButtonProps = _compactProps5$Button === void 0 ? {} : _compactProps5$Button,
          LabelComponent = _compactProps5.LabelComponent,
          hasSpan = _compactProps5.hasSpan;

      var errorElement = this.getErrorElement();
      var result = [];
      var totalChildrenNumber = 0;

      if (!show) {
        return null;
      }

      this.valueMap = {}; // 筛选出需要的元素

      if ((0, _spauiUtils.isArray)(data)) {
        totalChildrenNumber = data.length;
        data.forEach(function (item, index) {
          if (_typeof(item) === 'object' && item) {
            var label = item.label,
                otherProps = _objectWithoutProperties(item, ["label"]);

            result.push(_this3.getCloneChildren(_react["default"].createElement(_spauiButton["default"], _extends({
              hasSpan: hasSpan
            }, ButtonProps, {
              disabled: disabled || otherProps.disabled || false,
              className: _this3.setChildrenItemClassName(otherProps.className, index, totalChildrenNumber, ButtonProps.className || ''),
              "data-value": otherProps.value
            }, otherProps), typeof LabelComponent === 'function' ? _react["default"].createElement(LabelComponent, {
              data: item,
              parentProps: _objectSpread({}, ButtonProps, {}, otherProps)
            }) : label), index));
          }
        });

        if (children) {
          result.push(children);

          if ((0, _spauiUtils.isArray)(children)) {
            totalChildrenNumber += children.length;
          } else {
            totalChildrenNumber += 1;
          }
        }
      } else if ((0, _spauiUtils.isArray)(children)) {
        totalChildrenNumber = children.length;
        children.map(function () {
          var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var index = arguments.length > 1 ? arguments[1] : undefined;

          if (!(typeof item === 'string' && (0, _spauiUtils.trim)(item).length < 1)) {
            result.push(_this3.getCloneChildren(item, index, totalChildrenNumber));
          }

          return item;
        });
      } else if (!(typeof children === 'string' && (0, _spauiUtils.trim)(children).length < 1) && typeof children !== 'undefined') {
        totalChildrenNumber = 1;
        result.push(this.getCloneChildren(children, 0, totalChildrenNumber));
      }

      if (!this.props.needButtonWrap && _react["default"].Fragment) {
        return _react["default"].createElement(_react["default"].Fragment, null, result, this.getFillRowChildren(totalChildrenNumber), errorElement);
      } // 如果有错误节点信息就放在按钮后方展示


      if (errorElement) {
        return _react["default"].createElement("div", (0, _spauiUtils.globalProps)(this.props, {
          className: (0, _classnames["default"])(!vertical && !justified ? "".concat(bsClass) : '', vertical ? "".concat(bsClass, "-stack") : '', justified ? "".concat(bsClass, "-justified ").concat(bsClass) : '', vertical && block ? 'btn-block' : '', multiple ? 'multiple' : '', theme ? "spaui-button-group-".concat(theme) : ''),
          supportAllEvents: true
        }, ButtonGroup), _react["default"].createElement("div", null, result, this.getFillRowChildren(totalChildrenNumber)), errorElement);
      }

      return _react["default"].createElement("div", (0, _spauiUtils.globalProps)(this.props, {
        className: (0, _classnames["default"])(!vertical && !justified ? "".concat(bsClass) : '', vertical ? "".concat(bsClass, "-stack") : '', justified ? "".concat(bsClass, "-justified ").concat(bsClass) : '', vertical && block ? 'btn-block' : '', multiple ? 'multiple' : '', theme ? "spaui-button-group-".concat(theme) : ''),
        supportAllEvents: true
      }, ButtonGroup), result, this.getFillRowChildren(totalChildrenNumber));
    }
  }]);

  return ButtonGroup;
}(_react.PureComponent); // 组件标记


_defineProperty(ButtonGroup, "propTypes", _buttongroup_props.propTypes);

_defineProperty(ButtonGroup, "defaultProps", _buttongroup_props.defaultProps);

(0, _spauiUtils.setComponentMark)(ButtonGroup, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = ButtonGroup;
exports["default"] = _default;